import { Box, Container } from '@chakra-ui/react';
import { NextPage } from 'next';
import { FormattedMessage, useIntl } from 'react-intl';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import { H1 } from '@/components/Heading';
import { MonthActionsGrid } from '@/components/MonthActions/MonthActionsGrid';
import Seo from '@/components/Seo';

import { MonthAction } from '@/models/cms/MonthAction';
import { LocaleProps } from '@/models/props/LocalizationProps';
import { MonthActionsService } from '@/services/MonthActionsService';
import filterByDates from '@/utils/FilterByDates';

type ActionsPageProps = {
    actions: MonthAction[];
};

export const Actions: NextPage<ActionsPageProps> = (props) => {
    const intl = useIntl();
    const { actions } = props;

    return (
        <>
            <Seo title={intl.formatMessage({ id: 'page.month-actions.title' })} />
            <Container maxW="container.lg" py={10}>
                <Box textAlign="center" mb={10}>
                    <H1 mb={0}>
                        <FormattedMessage id="page.month-actions.title" />
                    </H1>
                </Box>
                <MonthActionsGrid data={actions} />
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    withSession<ActionsPageProps>(async (context) => {
        const { locale } = context;
        let actions: MonthAction[] = [];

        try {
            actions = await MonthActionsService.getMonthActions(locale as LocaleProps).then(
                (response) => response.data.data
            );
            actions = filterByDates(actions);
        } catch {
            /* empty */
        }

        return {
            props: {
                actions
            }
        };
    })
);

export default Actions;
